import { IdTypes, createFeatureScope } from 'bundles/product-features';

export type PropsWithRecruitingFlags = {
  recruitingEnabled?: boolean;
  recruitingAnonymizationEnabled?: boolean;
};

export const useEnableLearnerProfileRecruiting = (orgId: string) => {
  const { useProductFeatures } = createFeatureScope({
    enterprise: {
      recruitingEnabled: false,
      recruitingAnonymizationEnabled: true, // True by default in the types
    },
  });

  const { features } = useProductFeatures({
    idType: IdTypes.Organization,
    id: orgId,
    skip: !orgId,
    ssr: true,
  });

  return {
    recruitingEnabled: features.get('enterprise', 'recruitingEnabled'),
    recruitingAnonymizationEnabled: !!orgId && features.get('enterprise', 'recruitingAnonymizationEnabled'),
  };
};
